module.exports = __webpack_public_path__ + "static/img/Qrcode.2ea31a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Qrcode.jpg
// module id = yta8
// module chunks = 2